import React, { useState } from "react";
import StaffBoiler from "./BoilerDetails";
import StaffShipPurifierDetails from "./PurifierDetails";
import StaffPumps from "./PumpDetails";
import StaffShipCompressorDetails from "./CompressorDetails";
import AuxiliaryMachinary from "./AuxiliaryMachinary";

function SubTabMachinary({ id }) {
  const [activeTab, setActiveTab] = useState("boilers");


  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "boilers" ? "active" : ""}
            onClick={() => handleClick("boilers")}
          >
            Boiler
          </li>
          <li
            className={activeTab === "purifier" ? "active" : ""}
            onClick={() => handleClick("purifier")}
          >
            Purifier
          </li>

          <li className={activeTab === "pump" ? "active" : ""} onClick={() => handleClick("pump")}>
            Pump
          </li>
          <li
            className={activeTab === "compressor" ? "active" : ""}
            onClick={() => handleClick("compressor")}
          >
            Air Compressor
          </li>
          <li
            className={activeTab === "auxiliaryMachinary" ? "active" : ""}
            onClick={() => handleClick("auxiliaryMachinary")}
          >
            Other Machinary
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "auxiliaryMachinary" && <AuxiliaryMachinary id={id} />}
        {activeTab == "boilers" && <StaffBoiler id={id} />}
        {activeTab == "pump" && <StaffPumps id={id} />}
        {activeTab == "compressor" && <StaffShipCompressorDetails id={id} />}
        {activeTab == "purifier" && <StaffShipPurifierDetails id={id} />}
      </div>
    </>
  );
}

export default SubTabMachinary;
